import { components } from '@/utils'

function renderItemSlot(item) {
  if (typeof this.$scopedSlots.item === 'function') {
    return this.$scopedSlots.item(item)
  }

  return item
}

function renderContent() {
  if (Array.isArray(this.items) && this.items.length) {
    return this.items.map(item => {
      return renderItemSlot.call(this, item)
    })
  }

  return this.$slots.default
}

export default function(h) {
  return h(
    'div',
    {
      attrs: { role: 'list' },
      class: {
        [`${components.list}`]: true,

        [`${components.list}--dense`]: this.dense,
        [`${components.list}--rounded`]: this.rounded,
        [`${components.list}--outline`]: this.outline,
        [`${components.list}--transparent`]: this.transparent
      }
    },
    [ renderContent.call(this) ]
  )
}
